import { Component } from '@angular/core';

@Component({
    selector: 'xm-display-card',
    styleUrls: ['./card.scss'],
    templateUrl: './card.html',
    standalone: false
})
export class XmDisplayCardComponent {}
